import { useState } from 'react';
import { Paper, Group, Image, ActionIcon } from '@mantine/core';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { pb } from '../../lib/pocketbase';

interface IstZustandMassnahme {
  id: string;
  anhaenge: string[];
}

interface ImageThumbnailProps {
  massnahme: IstZustandMassnahme;
}

export function ImageThumbnail({ massnahme }: ImageThumbnailProps) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!massnahme.anhaenge || massnahme.anhaenge.length === 0) {
    return null;
  }

  const handlePrevious = () => {
    setCurrentImageIndex((prev) => 
      prev === 0 ? massnahme.anhaenge.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentImageIndex((prev) => 
      prev === massnahme.anhaenge.length - 1 ? 0 : prev + 1
    );
  };

  const getImageUrl = (fileId: string) => {
    return pb.files.getURL(massnahme, massnahme.anhaenge[currentImageIndex], {
      thumb: '100x100',
    });
  };

  return (
    <Paper 
      p={0}
      style={{ 
        position: 'relative',
        width: '100%',
        aspectRatio: '1',
        overflow: 'hidden'
      }}
    >
      <Image
        src={getImageUrl(massnahme.anhaenge[currentImageIndex])}
        alt={`Image ${currentImageIndex + 1}`}
        fit="cover"
        height="100%"
        style={{ 
          width: '100%', 
          height: '100%',
          display: 'block'
        }}
      />
      
      {massnahme.anhaenge.length > 1 && (
        <>
          <ActionIcon
            variant="filled"
            color="dark"
            size="sm"
            style={{
              position: 'absolute',
              left: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              opacity: 0.7,
            }}
            onClick={handlePrevious}
          >
            <IconChevronLeft size={14} />
          </ActionIcon>

          <ActionIcon
            variant="filled"
            color="dark"
            size="sm"
            style={{
              position: 'absolute',
              right: 4,
              top: '50%',
              transform: 'translateY(-50%)',
              opacity: 0.7,
            }}
            onClick={handleNext}
          >
            <IconChevronRight size={14} />
          </ActionIcon>

          <Group 
            justify="center" 
            style={{ 
              position: 'absolute', 
              bottom: 4, 
              left: 0, 
              right: 0,
              gap: '4px'
            }}
          >
            {massnahme.anhaenge.map((_, index) => (
              <div
                key={index}
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: index === currentImageIndex ? 'white' : 'rgba(255, 255, 255, 0.5)',
                }}
              />
            ))}
          </Group>
        </>
      )}
    </Paper>
  );
}
